import React from "react";
import s from "./PageTitle.module.scss";

// Section heading in the same style as the home page: gold rule + eyebrow
// label above a large title. Spacing is left to the page via className.
const PageTitle = ({ eyebrow, title, className }) => (
  <div className={className ? `${s.title} ${className}` : s.title}>
    {eyebrow && <div className={s.eyebrow}>{eyebrow}</div>}
    <h2 className={s.h2}>{title}</h2>
  </div>
);

export default PageTitle;
